define('ItemRelations.Correlated.View.Extension', [
  'ItemRelations.Correlated.View',
  'underscore'
], function (View, _) {
  'use strict';

  return _.extend(View.prototype, {
    initialize: _.wrap(View.prototype.initialize, function (fn) {
      var result = fn.apply(this, _.toArray(arguments).slice(1));
      var layout = this.options.application.getLayout();

      layout && layout.on('afterAppendView', this.loadRelatedItems, this);

      return result;
    })
  });
});
